export default __webpack_public_path__ + "static/icon-1efebc94862826b5a171b9da6e7bfcd6.png";